import styled from 'styled-components';
import Headline from './Headline';
import {
  Headline400Skin,
  Headline500Skin,
  Headline600Skin,
  Headline700Skin,
  Headline800Skin,
} from './HeadlineSkins';

export const Headline800 = styled(Headline)`
  ${Headline800Skin}
`;

export const Headline700 = styled(Headline)`
  ${Headline700Skin}
`;

export const Headline600 = styled(Headline)`
  ${Headline600Skin}
`;

export const Headline500 = styled(Headline)`
  ${Headline500Skin}
`;

export const Headline400 = styled(Headline)`
  ${Headline400Skin}
`;
